<template>
  <div class="container">
    <div
      :class="[(this.$store.state.alertAtualizacoes.alertAtualizacoes.show === true) ? 'in show' : '', 'modal fade']"
      role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="back-header modal-header">
            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
            <h4 class="modal-title alert-title color-h4">⚠️ Últimas atualizações do sistema ⚠️</h4>
          </div>
           <div class="modal-body">
            <div  id="loadContent0" style="display:none !important"></div>
            <div  id="loadContent"></div>
          </div>
          <div class="modal-footer">
            <a href="https://manual.portalssp.com/notas-ssp-financeiro/" target="_blank"><button type="button" class="btn btn-default" data-dismiss="modal">Ver Mais</button></a>
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="fecharModal()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
export default {
  updated: function () {
    this.carregaExterno()
  },
  methods: {
    carregaExterno: function () {
      if (this.$store.state.alertAtualizacoes.alertAtualizacoes.show === true) {
        $('#loadContent').load('https://manual.portalssp.com/notas-ssp-financeiro/ div.bloco-conteudo', function (data, status, jqXGR) { // callback function
          let conteudo = '' // '<div class="list-group-item list-group-item-info">  </div>'
          $('#loadContent article').each(function () {
            conteudo += '<div class="list-group-item list-group-item-light">' + $(this).find('.entry-title').text() + ' <br> ' + $(this).find('.post-meta').text() + '</div>'
          })
          $('#loadContent').html(conteudo)
        })
      }
    },
    fecharModal: function () {
      this.$store.commit('setAlertAtualizacoes', {status: true, show: false})
    }
  }
}
</script>
<style scoped>
  .color-h4 {
    color: white;
  }
  .modal-body{
    width: 100%;
    max-height: 350px;
    overflow: auto;
  }
  .alert-title {
    text-align: center;
    font-size: 1.7em;
  }
  .back-header {
    color: #041c38;
    background-color: red;
    border-color: #c3e6cb;
  }
  .alert-title span {
    transform: rotate(90deg);
    display: inline-block;
    font-size: 1.1em;
    margin-left: .5em;
    font-weight: 600;
  }
  .modal {
    z-index: 100000;
  }
  .modal-dialog {
    min-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// AlertAtualizacoes.vue?49999bf0